import { gql } from '@apollo/client';

import { subscriptionPartial } from '../partials';
import { cartPartial } from '../partials/cart/Cart';

export const cleanCart = gql`
  mutation emptyCart {
    emptyCart(input: { clearPersistentCart: true }) {
      ${cartPartial(subscriptionPartial)}
    }
  }
`;
